import { GenericOfficeIDs, TrackingEvent } from '@caresend/types';
import { getUserPath } from '@caresend/utils';
import 'firebase/auth';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../database/firebaseConfig/init.js';
import { dbUpdate } from '../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import { toastErrorAndReport } from '../../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../../components/ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import { trackEvent } from '../../../../functions/tracking/tracking.js';
import { getStore } from '../../../helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { getRoute } from '../../../../router/helpers/initRouter.js';
import { SchedulingFlowRouteName } from '../../../../router/routes/schedulingFlow/model.js';
import { setUserPhone } from '../../../../components/specific/schedulingFlow/PrimaryContact/helpers.js';
import { confirmVisit } from '../helpers/finalization.js';

// ROOT STEPS
const addressCompletionAction = async (_route) => {
    const store = getStore();
    /**
     * The Location input on this page manages the location property on the
     * Scheduling flow state
     *
     * On confirm we want to save this data to the draft waypoint
     */
    try {
        if (!store.state.schedulingFlow.location) {
            throw new Error('Address is required');
        }
    }
    catch (error) {
        toastErrorAndReport(error);
    }
};
const visitOverviewCompletionAction = async (_route) => {
    const maybeUpdateUserPhone = async () => {
        var _a, _b, _c, _d, _e, _f, _g;
        const store = getStore();
        const { primaryContact } = store.state.schedulingFlow;
        if (!(primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.custom)) {
            if (!primaryContact)
                throw Error('Primary contact not found when completing visit overview');
            if (!primaryContact.phone)
                throw Error('Primary contact phone number not found when completing visit overview');
            if (!primaryContact.userID)
                throw Error('Primary contact ID not found when completing visit overview');
            const existingUser = (_a = store.getters['users/getStaffUserByID'](primaryContact.userID)) !== null && _a !== void 0 ? _a : store.state.schedulingFlow.patients[primaryContact.userID];
            if (((_c = (_b = existingUser === null || existingUser === void 0 ? void 0 : existingUser.info) === null || _b === void 0 ? void 0 : _b.phone) === null || _c === void 0 ? void 0 : _c.countryCode) !== ((_d = primaryContact.phone) === null || _d === void 0 ? void 0 : _d.countryCode)
                || ((_f = (_e = existingUser === null || existingUser === void 0 ? void 0 : existingUser.info) === null || _e === void 0 ? void 0 : _e.phone) === null || _f === void 0 ? void 0 : _f.number) !== ((_g = primaryContact.phone) === null || _g === void 0 ? void 0 : _g.number)) {
                await setUserPhone(primaryContact.userID, primaryContact.phone);
            }
        }
    };
    await maybeUpdateUserPhone();
    await confirmVisit();
};
const completeProfileCompletionAction = async (_route) => {
    var _a, _b;
    const store = getStore();
    try {
        const userProfile = store.state.schedulingFlow.patientInitiatedUserProfile;
        const userID = (_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.id;
        if (!userID) {
            throw new Error('User needs to be logged in.');
        }
        await dbUpdate(getUserPath(userID, 'info'), userProfile);
    }
    catch (error) {
        toastErrorAndReport(error);
    }
    finally {
        const isOfficeGeneric = ((_b = store.state.orderFlow.draftOrder) === null || _b === void 0 ? void 0 : _b.officeID) === GenericOfficeIDs.PATIENT_INITIATED;
        if (!isOfficeGeneric)
            store.dispatch('schedulingFlow/maybeRouteToExitRoute');
    }
};
const practiceInfoCompletionAction = async (_route) => {
    const store = getStore();
    const route = getRoute();
    try {
        const { practiceInfo, draftWaypoint } = store.state.schedulingFlow;
        const { draftOrderID } = route.value.params;
        await trackEvent(store, TrackingEvent.ORDER_INTAKE_DOCTOR_INFO, {
            ...practiceInfo,
            draftOrderID,
            draftWaypointID: draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.id,
        });
    }
    catch (error) {
        toastErrorAndReport(error);
    }
    finally {
        store.dispatch('schedulingFlow/maybeRouteToExitRoute');
    }
};
/**
 * If a completion action is defined, the next button will trigger that action
 * rather than being a `<router-link>` to the next step. While the async action
 * is in progress, a loader will show on the next button. If the promise
 * resolves, the user will be navigated to the next step.
 *
 * **To cancel navigation, an error must be thrown.** Errors thrown within these
 * actions will be shown to the user and prevent navigation to the next step.
 */
const schedulingFlowCompletionActions = {
    [SchedulingFlowRouteName.SCHEDULING_FLOW_ADDRESS]: addressCompletionAction,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_VISIT_OVERVIEW]: visitOverviewCompletionAction,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_COMPLETE_PROFILE]: completeProfileCompletionAction,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_PRACTICE_INFO]: practiceInfoCompletionAction,
};

export { schedulingFlowCompletionActions, visitOverviewCompletionAction };
